import React from "react";
import { NavLink } from "react-router-dom";
import { NAV_LINKS, URLS } from "utils/constants";
import { useAuth } from "hooks/useAuth";
import "./WorkshopTopbar.css";

const topbarHrefOrder = [
  URLS.v1.WORKSHOP,
  URLS.v1.WORKSHOP_INVENTORY,
  URLS.v1.WORKSHOP_SUPPLIER,
  URLS.v1.WORKSHOP_PURCHASE_ORDERS,
  URLS.v1.WORKSHOP_PURCHASE_RECEIPTS,
  URLS.v1.WORKSHOP_SERVICE_REPORTS,
  URLS.v1.WORKSHOP_STOCK_TRANSFERS,
];

const workshopMenu = NAV_LINKS.find((link) => link.name === "Workshop");

const WorkshopTopbar = () => {
  const { user } = useAuth();
  const userRoles = user?.roles?.map((role) => role.name) || [];
  const hasAccess = (allowedRoles = []) => userRoles.some((role) => allowedRoles.includes(role));
  const orderedLinks = topbarHrefOrder
    .map((href) => workshopMenu?.child?.find((item) => item.href === href))
    .filter(Boolean)
    .filter((item) => hasAccess(item.roles || []));

  if (orderedLinks.length === 0) {
    return null;
  }

  return (
    <div className="workshop-topbar">
      <div className="workshop-topbar-scroll">
        {orderedLinks.map(({ name, href, icon: Icon }) => (
          <NavLink key={href} to={href} end={href === URLS.v1.WORKSHOP} className={({ isActive }) => `workshop-topbar-link ${isActive ? "active" : ""}`}>
            <Icon size={15} />
            <span>{name}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default WorkshopTopbar;
